/* Header count reads the actual cart; never modifies cart contents. */
(() => {
  if (window.LPHeaderCount) return;
  const originalFetch = window.fetch.bind(window);
  let count = null, timer, running = false, dirty = false;
  function paint() {
    if (count === null) return;
    document.querySelectorAll('#cart-icon-bubble').forEach(link => {
      let badge = link.querySelector('.cart-count-bubble');
      if (!count) { if (badge) badge.remove(); return; }
      if (!badge) { badge = document.createElement('div'); badge.className = 'cart-count-bubble'; link.appendChild(badge); }
      const text = String(count);
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.getAttribute('aria-label') !== `${count} items in cart`) badge.setAttribute('aria-label', `${count} items in cart`);
      if (badge.getAttribute('role') !== 'status') badge.setAttribute('role', 'status');
    });
  }
  async function refresh() {
    if (running) { dirty = true; return; }
    running = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await originalFetch(root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (response.ok) {
        const cart = await response.json();
        if (Number.isInteger(cart.item_count) && cart.item_count >= 0) {count = cart.item_count; paint();}
      }
    } catch (_) { /* Keep server-rendered count on temporary network failures. */ }
    finally {running = false; if (dirty) {dirty = false; schedule();}}
  }
  function schedule() {clearTimeout(timer); timer = setTimeout(refresh, 150);}
  window.fetch = async function(input, init) {
    let mutation = false;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const method = String(init?.method || input?.method || 'GET').toUpperCase();
      mutation = url.origin === location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch (_) {}
    const response = await originalFetch(input, init);
    if (mutation && response.ok) schedule();
    return response;
  };
  window.LPHeaderCount = {refresh:schedule};
  function init() {
    const header = document.querySelector('.section-header') || document.querySelector('header');
    if (header) new MutationObserver(paint).observe(header, {childList:true,subtree:true});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    ['cart:updated','cart:refresh','shopify:cart:updated'].forEach(name => document.addEventListener(name,schedule));
    window.addEventListener('pageshow',schedule);window.addEventListener('focus',schedule);schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
